import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { DashboardWidgetConfig } from 'ux/Tenant/Dashboard/types';

export type DashboardState = {
  widgetConfigs: DashboardWidgetConfig[][] | null;
};

const initialState: DashboardState = {
  widgetConfigs: null
};

const dashboardSlice = createSlice({
  name: 'Dashboard',
  initialState,
  reducers: {
    setWidgetConfigs: (state, { payload }: PayloadAction<DashboardWidgetConfig[][]>) => {
      state.widgetConfigs = payload;
    }
  }
});

export const { actions } = dashboardSlice;
export default dashboardSlice.reducer;
